// VIDAT visual assets — watercolour illustrations (artistic, sober medical tone).

export const VIDAT_IMG = {
  monasterio1: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/9z3nfrc6_Acuarela%20monasterio%201.png',
  monasterio2: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/jqxlk8me_Acuarela%20monasterio%202.png',
  estanque1: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/o0r0x26h_Estanque%20guinardera%201.png',
  estanque2: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/4joa65yr_Estanque%20guinardera%202.png',
  manos: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/ivcqv309_Manos%20medico%20y%20paciente.png',
  // Legacy alias for any leftover references — points to a neutral landscape.
  santCugat: 'https://customer-assets.emergentagent.com/job_vidat-salud/artifacts/jqxlk8me_Acuarela%20monasterio%202.png',
};
